<h1 mat-dialog-title>{{ 'suppliers.dialog.new' | translate }}</h1>
<mat-dialog-content>
  <app-card-spinner [visible]="dialogIsLoading" type="zero"></app-card-spinner>
  <div *ngIf="loggedUserRoleType === 'admin' || loggedUserRoleType === 'operator'" class="addSupplierDialogBox">
    <div class="row">
      <div class="col-8">{{ 'suppliers.dialog.textSearchExternal' | translate }}</div>
      <div class="col-4 text-right">
        <button mat-raised-button color="primary" (click)="onExternalSearch()">
          {{ 'suppliers.dialog.btnSearchExternal' | translate }}
        </button>
      </div>
    </div>
    <div *ngIf="dataFromOpenApi" class="addSupplierDialogTable">
      <table class="table table-borderless table-striped" *ngIf="suppliersFromOpenApi.length">
        <thead>
          <th>{{ 'suppliers.dialog.table.companyName' | translate }}</th>
          <th>{{ 'suppliers.dialog.table.vatNumber' | translate }}</th>
          <th>{{ 'suppliers.dialog.table.taxCode' | translate }}</th>
          <th>{{ 'suppliers.dialog.table.address' | translate }}</th>
        </thead>
        <tbody>
          <tr *ngFor="let item of suppliersFromOpenApi" style="cursor: pointer" (click)="onSelectedItem(item)">
            <td>{{ item.companyName }}</td>
            <td>{{ item.vatCode }}</td>
            <td>{{ item.taxCode }}</td>
            <td>{{ item.address?.simpleValue }}</td>
          </tr>
        </tbody>
      </table>
      <div class="alert alert-danger" role="alert" *ngIf="!suppliersFromOpenApi.length && !dialogIsLoading">
        {{ 'suppliers.dialog.noData' | translate }}
      </div>
    </div>
  </div>
  
  <div class="form-wrapper mt-3">
    <form [formGroup]="form">
      <formly-form [form]="form" [fields]="fields" [model]="model" [options]="options"></formly-form>
    </form>
  </div> <!-- /.form-wrapper -->
</mat-dialog-content> <!-- mat-dialog-content -->
<div class="col-12 pb-4" mat-dialog-actions>
  <div class="col-6 text-left">
    <div class="w-100">
      <a mat-button (click)="onClose()" mat-raised-button mat-default
        class="ml-3">{{ 'common.cta.close' | translate }}</a>
    </div>
  </div>
  <div class="col-6 text-right">
    <mat-spinner-button (btnClick)="onFormSubmit(model)" role="submit" [options]="formBtnOptions" class="btn-elevate">
    </mat-spinner-button>
  </div>
</div>